import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import $axios from './index';

// Fetch all shipping charges (GET)
export const getAllShippingCharges = createAsyncThunk('get All shipping charges', async () => {
  let response = [null, null];
  try {
    const res = await $axios.get('/shipping-charge');
    response = [res.data.data, null];
  } catch (err) {
    response = [null, err?.response || 'Something went wrong'];
  } finally {
    return response;
  }
});

// Fetch a single shipping charge by ID (GET)
export const getShippingChargeById = createAsyncThunk('get Single shipping charge', async (id) => {
  let response = [null, null];
  try {
    const res = await $axios.get(`/shipping-charge/${id}`);
    response = [res.data.data, null];
  } catch (err) {
    response = [null, err?.response?.data?.message || err?.response || 'Something went wrong'];
  } finally {
    return response;
  }
});

// Create a new shipping charge (POST)
export const createShippingCharge = createAsyncThunk('create shipping charge', async (obj) => {
  let response = [null, null];
  try {
    const res = await $axios.post('/shipping-charge', obj);
    response = [res.data.data, null];
  } catch (err) {
    response = [null, err?.response?.data?.message || err?.response || 'Something went wrong'];
  } finally {
    return response;
  }
});

// Update an existing shipping charge (PUT)
export const updateShippingCharge = createAsyncThunk('update shipping charge', async ({ id, region, charge }) => {
  let response = [null, null];
  try {
    const res = await $axios.put(`/shipping-charge/${id}`, { region, charge });
    response = [res.data.data, null];
  } catch (err) {
    response = [null, err?.response?.data?.message || err?.response || 'Something went wrong'];
  } finally {
    return response;
  }
});

// Delete a shipping charge (DELETE)
export const deleteShippingCharge = createAsyncThunk('delete shipping charge', async (id) => {
  let response = [null, null];
  try {
    const res = await $axios.delete(`/shipping-charge/${id}`);
    response = [res.data.data, null];
  } catch (err) {
    response = [null, err?.response || 'Something went wrong'];
  } finally {
    // console.log(response);
    return response;
  }
});

export const resetShippingChargeState = createAsyncThunk('reset all shipping charge state', async () => {
  return 'reset all shipping charge state';
});

// Slice
const shippingChargeSlice = createSlice({
  name: 'shippingChargeSlice',
  initialState: {
    allShippingCharges: null,
    singleShippingCharge: null,
    singleShippingChargeDeleted: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    // Fetch all
    builder
      .addCase(getAllShippingCharges.pending, (state) => {
        state.allShippingCharges = null;
      })
      .addCase(getAllShippingCharges.fulfilled, (state, action) => {
        state.allShippingCharges = action.payload;
      });

    // Fetch single
    builder
      .addCase(getShippingChargeById.pending, (state) => {
        state.singleShippingCharge = null;
      })
      .addCase(getShippingChargeById.fulfilled, (state, action) => {
        state.singleShippingCharge = action.payload;
      });

    // Create
    builder
      .addCase(createShippingCharge.pending, (state) => {
        state.singleShippingCharge = null;
      })
      .addCase(createShippingCharge.fulfilled, (state, action) => {
        state.singleShippingCharge = action.payload;
      });

    // Update
    builder.addCase(updateShippingCharge.fulfilled, (state, action) => {
      if (state.allShippingCharges) {
        state.allShippingCharges = state.allShippingCharges.map((item) => (String(item._id) === String(action.payload._id) ? action.payload : item));
      }
    });

    // Delete
    builder.addCase(deleteShippingCharge.fulfilled, (state, action) => {
      state.singleShippingChargeDeleted = { ...action.payload[0] };
    });

    // Reset
    builder.addCase(resetShippingChargeState.fulfilled, (state) => {
      state.allShippingCharges = null;
      state.singleShippingCharge = null;
      state.singleShippingChargeDeleted = null;
    });
  },
});

export default shippingChargeSlice.reducer;
